import React, { forwardRef } from 'react'
import MessageBox from './MessageBox'
import { IoMdInformationCircle } from "react-icons/io";

const AdminCustomSelect = forwardRef(({ name, value, onChange, options, defaultOptionName, defaultOptionName2, error, noMargin, className, noBorder, defaultValue, id, formatOptionLabel, customWidth, ...rest }, ref) => {
    return (
        <>
            <select
                name={name}
                value={value || defaultValue}
                onChange={onChange}
                ref={ref}
                id={id || "selectField"}
                data-test-id={id || "selectField"}
                {...rest}
                className={`custom-input ${!noBorder ? 'custom-input-border' : ''} ${customWidth ?? 'w-100'} ${!noMargin ? "mb-3" : ""} ${className} custom-placeholder bg-transparent theme-text-color ${error && 'custom-input-error'}`}>
                {defaultOptionName && <option className=" theme-text-color" value="">{defaultOptionName}</option>}
                {defaultOptionName2 && <option className=" theme-text-color" value="0">{defaultOptionName2}</option>}
                {options?.map((item, index) => (
                    <option data-index={`dropdown-option-${index}`} key={index} id={`${item?.value}`} value={item?.value} className="theme-bg-color theme-text-color">
                        {formatOptionLabel ? formatOptionLabel(item) : item?.name}
                    </option>
                ))}
            </select>
            {error && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${error}`} classname='errorred  d-block' /></div>)}
        </>)
})

export default AdminCustomSelect
